export interface EducationData {
    establishmentName: string;
    location: string;
    attendedDate: string;
    accomplishment: string;
}

const data: EducationData[] = [
    {
        establishmentName: 'University of Washington',
        location: 'Tacoma, WA',
        attendedDate: 'September 2010 - June 2013',
        accomplishment: 'Bachelor of Science in Computer Science and Systems',
    },
];

export default data;
